<template>
    <div class="form-agency-documents">
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4">
                <div class="row" v-for="(document, index) in documents" :key="index" v-if="document.static">
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div class="form-field form-field--text">
                            <label for="name">
                                {{ document.name }} <i @click="(e) => handleEditDocument(e, document.id)" style="cursor: pointer;" class="icon icon-pencil"></i> <i @click="deleteDocument(document.id)"  style="cursor: pointer;" class="icon icon-trash"></i>
                            </label>
                            <a style="color: #e74c3c;cursor: pointer;" v-if="document.url.length > 0" :href="document.url">{{ document.url}}</a>
                            <small v-else>-</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-8">
                <div class="row">
                    <div class="form-table">
                        <div class="form-table__header right">
                            <span @click="toggleAddLinkModal">Add reference link</span>
                        </div>
                        <div class="form-table__wrap table-wrap">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>
                                        Document
                                    </th>
                                    <th>
                                        Link
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(document, index) in documents" :key="index" v-if="!document.static">
                                    <td>
                                        {{ document.name }}
                                    </td>
                                    <td>
                                        <a :href="document.url">{{ document.url }}</a>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn--icon"
                                            type="button"
                                            @click="(e) => handleEditDocument(e, document.id)"
                                        >
                                            <i class="icon icon-pencil"></i>
                                        </button>
                                        <button @click="deleteDocument(document.id)"
                                            class="btn btn--icon"
                                            type="button"
                                        >
                                            <i class="icon icon-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AddLinkModal :agency="agency" v-if="isAddLink" :onClose="toggleAddLinkModal" :onAdd="handleAddLink"
                      :isEdit="editId" :onEdit="editDocument" :editData="editData"/>
    </div>
</template>

<script>

import AddLinkModal from './AddLink.vue';

export default {
    name: "documentsTab",
    props: ['agency'],
    components: {
        AddLinkModal
    },
    data() {
        return {
            documents: [],
            isAddLink: false,
            editId: null
        }
    },
    mounted() {
        this.getAgencyDocuments();
    },

    computed: {

        editData() {
            if (this.editId && this.documents.length) {
                return this.documents.find(doc => doc.id === this.editId)
            }
            return null
        }
    },
    methods: {
        deleteDocument(documentId) {
            if (confirm('Are you sure?')) {
                axios.post('/agencies/documents/deleteDocument', {
                    agency_id: this.agency.id,
                    document_id: documentId
                }).then(r => {
                    this.getAgencyDocuments()
                });
            }
        },
        getAgencyDocuments() {
            axios.post('/agencies/documents/getDocumentList', {
                agency_id: this.agency.id,
            }).then(r => {
                this.documents = r.data;
            });
        },
        toggleAddLinkModal(e) {
            e.preventDefault();
            this.isAddLink = !this.isAddLink
            if (!this.isAddLink) {
                this.editId = null;
            }
        },
        handleAddLink(data) {
            axios.post('/agencies/documents/addDocument', {
                agency_id: this.agency.id,
                document_id: data.type,
                name: data.name,
                url: data.url,
                is_common: data.common,
                is_static: data.static,
            }).then(r => {
                if (r.data.isSuccess) {
                    this.isAddLink = false;

                    this.getAgencyDocuments()
                }

            });
        },
        inputHandler(value, e) {
            const id = e.target.id;

            console.log(id, value);
        },
        handleEditDocument(e, id) {
            this.editId = id;
            this.toggleAddLinkModal(e);
        },
        editDocument(id, data) {
            // const editData = this.documents.map(doc => {
            //     if (id === doc.id) {
            //         doc.common = data.common;
            //         doc.name = data.name;
            //         doc.static = data.static;
            //         doc.type = data.type;
            //         doc.url = data.url;
            //     }
            //     return doc;
            // })

            // this.documents = editData;

            axios.post('/agencies/documents/editDocument', {
                // agency_id: this.agency,
                document_id: id,
                url: data.url,
                // cases_url: data.cases_url,
            }).then(r => {
                if (r.data.isSuccess) {
                    this.isAddLink = false;
                    this.editId = null;

                    this.getAgencyDocuments();
                }

            });
        }
    }
};
</script>
